import type { FC } from "react";
import type { MatchTypes as MatchTypesProps } from "@motain/xpa-proto-files-web/lib/types/matches_filters_component";
import { Chip } from "@/xpa-components/chip/Chip";

import styles from "./MatchTypes.module.scss";

export const MatchTypes: FC<MatchTypesProps> = (props) => {
  const { buttons } = props;

  return (
    <section className={styles.container}>
      {buttons.map((button) => (
        <Chip key={button.uiKey} {...button} className={styles.chips} />
      ))}
    </section>
  );
};
